
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			isMounted: false
		};
	},
	props: {
		color: String,
		value: Number,
		small: Boolean,
		large: Boolean,
		multiplier: Number,
		duration: {
			type: String,
			default() {
				return "1s";
			}
		},
	},
	computed: {
		sizeMultiplier():number {
			if(this.multiplier){
				return this.multiplier;
			}
			if(this.small) {
				return .5;
			}
			if (this.large) {
				return 2;
			}
			return 1;
		},
		size():string {
			return (this.sizeMultiplier * 50) + "";
		},
		position():any {
			let angle = (100 - this.value + 50) * 3.6;
			let angleRadians = angle * Math.PI / 180;
			let x = Math.sin(angleRadians) * 20;
			let y = Math.cos(angleRadians) * 20;
			y += 20;
			return {x, y};
		},
		strokeSize():number {
			return Math.min(10 * this.sizeMultiplier, 5);
		},
		d():string {
			let size = 20 * this.sizeMultiplier;
			let strokeSize = 5 * this.sizeMultiplier; // Different strokesize. Otherwise it's not centered
			if (this.undetermind) {
				return `M${25 * this.sizeMultiplier} ${strokeSize} a${size},${size} 0 1,0 ${size},${size}`;
			}
			let d = `M${25 * this.sizeMultiplier} ${strokeSize} a${size},${size} `;
			if (this.value > 50) {
				d += "0 1,1 ";
			} else {
				d += "0 0,1 ";
			}
			d += this.position.x * this.sizeMultiplier + "," + this.position.y * this.sizeMultiplier;
			return d;
		},
		undetermind(): boolean {
			return this.value == null;
		},
		angle(): number {
			if (this.undetermind) return 180;
			return this.value / 100.0 * 360;
		},
		colorValue(): string {
			if (!this.isMounted) return "";
			if (this.color) {
				return this.color;
			}
			let element = this.$refs.div as HTMLElement;
			return getComputedStyle(element).getPropertyValue("--color");
		}
	},
	mounted() {
		this.isMounted = true;
	}
});
